import React from 'react';
import { Button } from '@/components/ui/button';
import { Check } from 'lucide-react';

interface CompletionStepProps {
  onComplete: () => void;
}

/**
 * Final step of the onboarding tour - Completion confirmation
 */
const CompletionStep: React.FC<CompletionStepProps> = ({ onComplete }) => {
  return (
    <div className="flex flex-col items-center space-y-6">
      <h2 className="text-2xl font-bold text-center">You have completed the initial onboarding!</h2>
      
      {/* Green checkmark icon */}
      <div className="w-24 h-24 bg-green-500 rounded-full flex items-center justify-center">
        <Check className="h-12 w-12 text-white" />
      </div>
      
      {/* Completion button */}
      <Button 
        onClick={onComplete}
        className="w-full bg-blue-500 hover:bg-blue-600 text-white py-3 px-6 text-lg"
      >
        Complete
      </Button>
    </div>
  );
};

export default CompletionStep;
